






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class MapOverlay extends Vue {
  @Prop() map!: google.maps.Map
  @Prop() type!: string
}
